export default {
    "MENUS": {
        "NAME": "Name",
        "COLOR": "Color",
        "LINK": "Link",
        "BACKGROUND": "Background image",
        "ICON": "Icon",
        "ACTIVE": "Active",
        "TILE": "Tile",
        "ORDER": "Order",
        "IS_EXTERNAL": "External",
        "IS_NEW_TAB": "New tab",
        "TYPE": "Type",
        "PARAMS": "Params",
        "BLOCK": "Block",
        "SITENOTIFICATIONS": "Alerts",
        "BUTTON": "Button",
    }
}



// WEBPACK FOOTER //
// ./src/i18n/messages/en/menus.js